"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterData = void 0;
const filterData = data => data != null;
exports.filterData = filterData;
